import * as data from './_data';
import * as type from './_type';

/** Common logic. */
const commonLogic = {
  type,
  data,
};

export type * from './_data.type';

export default commonLogic;
